import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=65738fa7&scoped=true"
import script from "./basicInfo.vue?vue&type=script&lang=js"
export * from "./basicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65738fa7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65738fa7')) {
      api.createRecord('65738fa7', component.options)
    } else {
      api.reload('65738fa7', component.options)
    }
    module.hot.accept("./basicInfo.vue?vue&type=template&id=65738fa7&scoped=true", function () {
      api.rerender('65738fa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operation/components/addContest/basicInfo.vue"
export default component.exports